import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingcabbookinginpune() {



  const cardData =
  {
    keyword: 'Wedding Cab Bookings in Pune',
    heading: 'Aaryan Travels: Wedding Cab Bookings in Pune',
    headingDescription: 'Aaryan Travels offers well-managed Wedding Cab Bookings in Pune to ensure smooth and elegant transportation for your big day. Whether you need luxury cars for the bride and groom, spacious SUVs for close family members, or tempo travellers for guest shuttles, we provide a complete wedding travel fleet with chauffeur-driven services. Decorated wedding cars, customized pickup schedules, and multiple vehicle coordination are available on request. From Kothrud to Kharadi, Pimpri-Chinchwad to Baner, Aaryan Travels delivers punctual and reliable wedding cab arrangements with style, comfort, and professionalism — making every arrival grand and memorable.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha grandeur. Its massive gateways, expansive lawns, and historical ruins attract history enthusiasts. The evening light-and-sound show narrates tales of Bajirao and Maratha valor. Despite fire damage, its legacy remains powerful. Shaniwar Wada is Pune’s majestic heart of heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic landmark associated with the Indian freedom struggle. Mahatma Gandhi and Kasturba Gandhi were imprisoned here during the Quit India Movement. Now converted into a museum, it displays personal belongings and photographs of Gandhi. The Italian arches and lush gardens add elegance. Aga Khan Palace is Pune’s tribute to sacrifice and peace."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched atop a hill, is famous for the 1670 battle where Tanaji Malusare fought bravely for Shivaji Maharaj. Trekkers enjoy scenic trails and breathtaking valley views. Local villagers serve spicy pithla-bhakri at the top. The fort is especially charming during monsoon. Sinhagad is Pune’s perfect blend of history, adventure, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Ganpati Temple is Pune’s most revered shrine, attracting thousands of devotees daily. The idol of Lord Ganesha, adorned with gold ornaments, stands in full glory. During Ganesh Chaturthi, the temple becomes the center of grand festivities. Peace and devotion fill the air. Dagdusheth is Pune’s spiritual anchor of faith."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine dedicated to Lord Shiva, carved in the 8th century. Its monolithic pillars and stone sanctum showcase early Indian craftsmanship. Despite being located in the city center, it maintains a tranquil atmosphere. Pataleshwar is Pune’s peaceful historical retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a fascinating collection of over 20,000 artifacts gathered by Dr. Dinkar Kelkar. It features sculptures, musical instruments, ornaments, and everyday objects from Indian culture. The recreated Mastani Mahal is a major highlight. The museum is Pune’s living archive of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill offers stunning panoramic views of Pune city after a climb of 103 steps. At the summit lies the Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. The peaceful surroundings make it ideal for sunrise and sunset visits. Parvati Hill is Pune’s sacred hilltop escape."
  },
  {
    "title": "Osho Ashram",
    "description": "Osho Ashram in Koregaon Park is a global meditation resort known for its wellness programs, silent gardens, and spiritual retreats. Visitors from around the world come for rejuvenation and inner peace. The modern architecture amidst lush greenery enhances the tranquil experience. Osho Ashram is Pune’s international center of mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Inspired by Japan’s Korakuen Garden, Pu La Deshpande Garden is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families enjoy evening walks and picnics amidst blooming flowers. The garden is beautifully maintained throughout the year. Pu La Deshpande Garden is Pune’s lush nature escape."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular scenic spot known for its tranquil waters and surrounding hills. During monsoon, the overflowing water creates a picturesque scene. Visitors enjoy roadside corn and tea while relaxing by the lakeside. It also serves as the starting point for Sinhagad trips. Khadakwasla is Pune’s breezy weekend getaway."
  }
],



 "services": [
  {
    "name": "Wedding Cab Bookings in Pune",
    "description": "Wedding Cab Bookings in Pune offer specialized transportation services designed to make your special day seamless and elegant. With a variety of luxury vehicles and professional chauffeurs, this service ensures timely arrivals, comfortable rides, and a touch of sophistication for the bride, groom, and guests. Ideal for weddings of all sizes, the service includes customizable packages to suit your specific needs, from single vehicle hires to full fleet arrangements."
  },
  {
    "name": "Bridal Car Rentals Pune",
    "description": "Bridal Car Rentals Pune provide premium vehicles dedicated to the bride’s transport needs. Featuring beautifully decorated cars and expert chauffeurs trained to ensure a smooth and memorable ride, these rentals focus on style, comfort, and punctuality. Whether you prefer classic vintage cars or modern luxury sedans, this service caters to every bride’s unique preferences and wedding theme."
  },
  {
    "name": "Wedding Transport Pune",
    "description": "Wedding Transport Pune covers all your logistical needs for wedding day travel, including guest pickups, venue transfers, and post-ceremony travel. Offering a fleet of well-maintained cars, SUVs, and luxury vehicles, this service prioritizes reliability, comfort, and efficient coordination to keep your wedding schedule running flawlessly."
  },
  {
    "name": "Luxury Wedding Cab Hire Pune",
    "description": "Luxury Wedding Cab Hire Pune specializes in premium chauffeur-driven cars for weddings, providing a high-end travel experience for the bridal party and VIP guests. With attention to detail in vehicle presentation and driver professionalism, the service ensures a lavish and stress-free transport experience, complementing the grandeur of your wedding celebrations."
  },
  {
    "name": "Chauffeur Wedding Car Pune",
    "description": "Chauffeur Wedding Car Pune offers expertly driven vehicles for weddings, with chauffeurs trained in etiquette and familiar with wedding day protocols. This service guarantees courteous, timely, and safe rides, making it ideal for brides, grooms, and close family members who desire a refined and hassle-free transport experience."
  },
  {
    "name": "Wedding Day Taxi Pune",
    "description": "Wedding Day Taxi Pune provides flexible and on-demand cab services for wedding-related travel. From shuttling guests between hotels and venues to last-minute transport needs, this service ensures prompt availability and courteous drivers, making it a reliable choice for dynamic wedding schedules."
  },
  {
    "name": "Premium Cab for Wedding Pune",
    "description": "Premium Cab for Wedding Pune offers luxury vehicles with premium amenities for wedding parties looking to travel in style. This service includes sedans, SUVs, and limousines equipped with modern comforts, driven by professional chauffeurs who prioritize discretion and punctuality."
  },
  {
    "name": "Pune Wedding Event Cab",
    "description": "Pune Wedding Event Cab coordinates transportation logistics for large wedding events, offering fleet management and scheduling services. Whether you need to transport hundreds of guests or manage multiple venues, this service provides seamless coordination, ensuring everyone arrives safely and on time."
  },
  {
    "name": "Affordable Wedding Car Pune",
    "description": "Affordable Wedding Car Pune delivers budget-friendly yet reliable and stylish transportation options for weddings. Perfect for couples seeking value without compromising quality, this service offers well-maintained vehicles, professional drivers, and flexible packages tailored to your budget."
  },
  {
    "name": "Classic Wedding Cabs Pune",
    "description": "Classic Wedding Cabs Pune features vintage and retro-style vehicles that add timeless charm to your wedding day. Ideal for traditional themes and photo shoots, these cabs come with skilled chauffeurs who ensure smooth rides and elegant appearances, making your special day truly unforgettable."
  },
  {
    "name": "Wedding SUV Rental Pune",
    "description": "Wedding SUV Rental Pune provides spacious and comfortable SUVs for family transport and larger bridal parties. With premium interiors and smooth handling, these vehicles are perfect for accommodating guests and ensuring a luxurious travel experience throughout the wedding festivities."
  },
  {
    "name": "Wedding Sedan Rental Pune",
    "description": "Wedding Sedan Rental Pune offers sleek and elegant sedans for the bride, groom, and close family members. These vehicles combine style and comfort, driven by professional chauffeurs who ensure timely and graceful arrivals at all wedding venues."
  },
  {
    "name": "Wedding Car Packages Pune",
    "description": "Wedding Car Packages Pune provide all-inclusive transportation plans tailored to your wedding day requirements. These packages can include multiple vehicles, chauffeur services, decoration, and flexible scheduling to ensure every aspect of your wedding transport is covered efficiently and professionally."
  },
  {
    "name": "Wedding Car Booking Services Pune",
    "description": "Wedding Car Booking Services Pune simplify the process of reserving the perfect vehicles for your wedding. With online booking options, customizable vehicle choices, and dedicated customer support, this service makes planning your wedding transportation hassle-free and reliable."
  },
  {
    "name": "Hire Wedding Vehicle Pune",
    "description": "Hire Wedding Vehicle Pune offers a diverse fleet of cars and SUVs available for hire on your wedding day. Whether you need a single luxury car for the bride or a fleet for guests, this service provides well-maintained vehicles, professional drivers, and flexible rental durations to suit your schedule."
  }
],
"tableData": [
  ["Wedding Cab Bookings in Pune", "Bridal Car Rentals Pune"],
  ["Wedding Transport Pune", "Luxury Wedding Cab Hire Pune"],
  ["Chauffeur Wedding Car Pune", "Wedding Day Taxi Pune"],
  ["Premium Cab for Wedding Pune", "Pune Wedding Event Cab"],
  ["Affordable Wedding Car Pune", "Classic Wedding Cabs Pune"],
  ["Wedding SUV Rental Pune", "Wedding Sedan Rental Pune"],
  ["Wedding Car Packages Pune", "Wedding Car Booking Services Pune"],
  ["Hire Wedding Vehicle Pune", "—"]
],




"whychoose": [
  {
    "WhyChooseheading": "Wedding Cab Bookings in Pune",
    "WhyChoosedescription": "Aaryan Travels offers reliable and elegant wedding cab bookings in Pune to make your special day seamless and memorable."
  },
  {
    "WhyChooseheading": "Luxurious and Well-Maintained Vehicles",
    "WhyChoosedescription": "Choose from our fleet of clean, stylish, and comfortable cars perfect for wedding ceremonies and related events."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs with Etiquette",
    "WhyChoosedescription": "Our courteous and experienced drivers ensure punctuality and respectful service during your wedding celebrations."
  },
  {
    "WhyChooseheading": "Vehicles Decorated as Per Your Preferences",
    "WhyChoosedescription": "We offer customized vehicle decoration services to add a special touch to your wedding cab experience."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Enjoy upfront pricing that covers all expenses, including fuel, tolls, and driver charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Wedding Bookings",
    "WhyChoosedescription": "Our dedicated team is available round the clock to assist with bookings and any last-minute changes."
  },
  {
    "WhyChooseheading": "Flexible Packages Tailored to Wedding Needs",
    "WhyChoosedescription": "Choose from customizable plans designed to fit your wedding schedule and transport requirements."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service on Your Big Day",
    "WhyChoosedescription": "We ensure timely pickups and drop-offs, so your wedding events run smoothly without any transportation hassles."
  }
]























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer wedding cab bookings in Pune?',
    answer: 'Yes, Aaryan Travels provides elegant and reliable wedding cab booking services in Pune to make your special day memorable.',
  },
  {
    question: 'How can I book wedding cab services in Pune with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team in Pune.',
  },
  {
    question: 'What types of vehicles are available for wedding cab bookings in Pune?',
    answer: 'Aaryan Travels offers a variety of well-maintained luxury sedans, SUVs, and premium cars perfect for wedding transportation.',
  },
  {
    question: 'Are drivers experienced and trained for wedding cab services in Pune?',
    answer: 'Absolutely. Our drivers are professional, courteous, and trained to provide a smooth and comfortable experience on your wedding day.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for wedding cab bookings in Pune?',
    answer: 'Yes, you can specify preferred pickup and drop-off points anywhere within Pune and nearby locations.',
  },
  {
    question: 'Is the wedding cab booking service available 24x7 in Pune?',
    answer: 'Yes, Aaryan Travels offers round-the-clock wedding cab booking services to suit your event schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for wedding cabs?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene standards for your peace of mind.',
  },
  {
    question: 'What payment options are accepted for wedding cab bookings in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the wedding cab booking period in Pune?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your wedding cab booking.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashwin Kulkarni',
    feedback: 'Aaryan Travels made our wedding cab bookings in Pune seamless and special with excellent service and professional drivers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Joshi',
    feedback: 'Highly recommend Aaryan Travels for wedding cab bookings in Pune. Punctual, elegant cars and courteous drivers made our day perfect.',
    rating: 5,
  },
];






















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];













  return (
    <div>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Weddingcabbookinginpune;